<template>
	<div class="tags page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<el-dialog title="编辑标签" width="500px" :visible="visible" @close="visible = false, dialogClose()">
			<el-form title="编辑标签" :model="tagsForm" :rules="rules" ref="tagsForm" label-width="100px">
				<el-form-item prop="tags" label="标签:">
					<el-input v-model="tagsForm.tags" placeholder="请输入标签"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="tagSubmit">保存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'tags',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 12,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加标签',
					sign: 'new'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
						prop: 'labelName',
						label: '标签',
						width: 800
					}],
					tableEvent: [{
						icon: 'el-icon-edit',
						name: '编辑',
						color: 'blue',
						sign: 'edit'
					}, {
						icon: 'el-icon-delete',
						name: '删除',
						color: 'red',
						sign: 'delete'
					}],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				visible: false,
				tagsForm: {
					tags: ''
				},
				rules: {
					tags: [{
						required: true,
						trigger: 'blur',
						message: '请输入标签'
					}]
				},
				operationId: ''
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData()
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.visible = true
				}
			},
			// 筛选条件变化
			filterChange() {
				console.log(this.filterValue);
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				this.operationId = row.id
				if (sign == 'edit') {
					this.tagsForm.tags = row.labelName
					this.visible = true
				}
				if (sign == 'delete') {
					this.$confirm('确认要删除这个标签吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.tagsDelete({
							id: row.id
						}, res => {
							if (res.code == 200) {
								this.operationId = ''
								this.fetchData()
								this.$message({
									message: '删除标签成功。',
									type: 'success',
									duration: 2000
								})
							}
						})
					}).catch(() => {});
				}
			},
			fetchData() {
				this.$api.tagsList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
					}
				})
			},
			tagSubmit() {
				this.$refs.tagsForm.validate(valid => {
					if (valid) {
						this.$api.tagsAdd({
							labelName: this.tagsForm.tags,
							id: this.operationId
						}, res => {
							if (res.code == 200) {
								this.visible = false
								this.fetchData()
								this.$message({
									type: 'success',
									message: '保存标签成功。',
									duration: 2000
								})
							}
						})
					}
				})
			},
			dialogClose(){
				this.operationId = ''
				this.tagsForm.tags = ''
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped"></style>
